// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b7b303ce","207":"0b00b2fd","361":"b642707f","477":"c7426972","836":"8db8bc82","950":"a6d09273"}[chunkId] + ".chunk.js";
};